import { render, staticRenderFns } from "./weblogCartMobile.vue?vue&type=template&id=f52cab5a&"
import script from "./weblogCartMobile.vue?vue&type=script&lang=js&"
export * from "./weblogCartMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports